<template>
    <div class="nav">
        <div class="head">
            <div class="name">
                <div class="oimg">
                    <img src="../assets/img/logo.png" alt />
                </div>
                <div class="spa">e博视智慧配电在线监测系统</div>
            </div>
            <div class="tatel">
                <div class="miti">
                    <!-- <i class="el-icon-warning"></i> -->
                </div>
                <div class="mixin">{{ title }}</div>
            </div>
        </div>
        <div class="ova">
            <div class="left-hand">
                <div class="Pngfute">
                    <div class="oimg">
                        <iframe ref="iframe" width="100%" height="100%" class="small" :src="src"
                            frameborder="0"></iframe>
                    </div>
                </div>
                <div class="state"></div>
                <div class="trigger">
                    <div class="swtrGet" @click="drawer = true" type="primary" style="margin-left: 16rem">
                        <i class="el-icon-sort"></i> 切换进线
                    </div>
                    <el-drawer title="回路" :visible.sync="drawer" :with-header="false">
                        <ul class="infinite-list" style="overflow: auto">
                            <div class="upward" @click="roll(1)">
                                <i class="el-icon-arrow-up"></i>
                            </div>
                            <div ref="apk" v-dragscroll class="vue-drag-scroll-out-wrapper">
                                <div class="vue-drag-scroll-wrapper" :style="zoomStye">
                                    <li @click="add(item.loopId, item)" v-for="item in bgonClick" class="jadk"
                                        v-bind:class="{ array: item.loopId == current }" :key="item.loopId">
                                        {{ item.loopName }}
                                    </li>

                                    <li class="nonum" v-if="bgonClick.length">{{ test }}</li>
                                    <li class="nonum" v-else>
                                        <div>
                                            <img src="../assets/img/not_found_data.png" alt />
                                        </div>
                                        暂无数据
                                    </li>
                                </div>
                            </div>
                            <div class="downward" @click="roll(2)">
                                <i class="el-icon-arrow-down"></i>
                            </div>
                        </ul>
                        <!-- <div class="jadk" v-for="item in bgonClick" :key="item.id">{{item.name}}</div> -->
                    </el-drawer>
                </div>
            </div>

            <!-- <div class="javafort" v-if="Isshow != 0">
         -->
            <div class="javafort">
                <div class="table-ele">
                    <el-table :row-class-name="tableRowClassName" :header-cell-style="tableHeaderColor" :data="Data"
                        border prop="name" width="100%">
                        <el-table-column prop="name" label></el-table-column>
                        <el-table-column prop="amount1" label="A/ab"></el-table-column>
                        <el-table-column prop="amount2" label="B/bc"></el-table-column>
                        <el-table-column prop="amount3" label="C/ac"></el-table-column>
                        <el-table-column prop="amount4" label="总"></el-table-column>
                        <el-table-column prop="spanw" label="单位"></el-table-column>
                    </el-table>
                </div>
                <!-- 需要更改的 -->
                <!-- <div class="Temperature">
                    <div class="web-left" v-for="(item, index) in Listgxg" :key="index">
                        <div class="header">
                            <div class="header-one">{{ item.id }}</div>
                            <div class="felx-right">
                                <div class="header-name">{{ item.name }}</div>
                                <div class="header-Icon">
                                    <img :src="item.Inimg" alt />
                                </div>
                            </div>
                        </div>
                        <div class="demo1">
                            <em>&#9670;</em>
                            <span>&#9670;</span>
                        </div>
                        <div class="Temperature-item">
                            <div class="ABC">
                                <span>温度#A</span>
                                <span>{{ item.TemperatureA }}</span>
                            </div>
                            <div class="ABC">
                                <span>温度#B</span>
                                <span>{{ item.TemperatureB }}</span>
                            </div>
                            <div class="ABC">
                                <span>温度#C</span>
                                <span>{{ item.TemperatureC }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Humidity">
                    <div class="web-left" v-for="(item, index) in Rhz" :key="index">
                        <div class="header">
                            <div class="felx-right">
                                <div class="header-name">{{ item.name }}</div>
                                <div class="header-Icon">
                                    <img :src="item.Inimg" alt />
                                </div>
                            </div>
                        </div>
                        <div class="demo1">
                            <em>&#9670;</em>
                            <span>&#9670;</span>
                        </div>
                        <div class="Temperature-item">
                            <div class="ABC">
                                <span>{{ item.data }}</span>
                                <span>{{ item.TemperatureA }}</span>
                            </div>
                            <div class="ABC"></div>
                            <div class="ABC"></div>
                        </div>
                    </div>
                </div> -->
            </div>
            <!-- <div class="mar" v-else>
        <div class="tors">
          <img src="../assets/img/not_found_data.png" alt />
          <div class="oP">
            暂无数据，请尝试
            <span class="antfos" @click="forsClick()" style="color: #0d94ff"
              >刷新</span
            >或切换日期
          </div>
        </div>
      </div> -->
        </div>
    </div>
</template>
<script>
    import chainIndex from "../api/play";
    import {
        connect as connectMqtt,
        subscribe,
        unsubscribe
    } from "../mqtt/index";
    export default {
        name: "ova",
        data() {
            return {
                title: "",
                test: "没有更多了",
                //默认参数
                titleAll: "T1/1AA1/XB11",
                //显示有数据
                Isshow: 0,
                //触摸滚动
                scale: 100,
                //回路弹窗状态
                drawer: false,
                //回路切换
                bgonClick: [],
                src: "",
                data: [],
                current: "",
            };
        },
        computed: {
            zoomStye() {
                //  const INIT_WIDTH = 2208
                //  const width = INIT_WIDTH * (1 + (100 - this.scale)/100)
                const INIT_HEIGHT = 1206;
                const height = INIT_HEIGHT * (1 + (100 - this.scale) / 100);
                return {
                    // width: `${width}rem`,
                    height: `${height}rem`,
                    transform: `scale(${this.scale / 100})`,
                };
            },
            Data() {
                return [{
                        id: "1",
                        name: "相电压",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/Ua") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ua") * 100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/Ub") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ub") * 100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/Uc") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Uc") * 100
                            ) / 100 : "--",
                        amount4: "--",
                        spanw: "v",
                    },
                    {
                        id: "2",
                        name: "线电压",
                        amount4: "--",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/Uab") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Uab") * 100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/Ubc") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ubc") * 100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/Uac") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Uac") * 100
                            ) / 100 : "--",

                        spanw: "v",
                    },
                    {
                        id: "3",
                        name: "电流",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/Ia") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ia") * 100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/Ib") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ib") * 100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/Ic") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Ic") * 100
                            ) / 100 : "--",
                        amount4: "--",
                        // (this.$store.getters.mqttVal(this.titleAll + "/Ia")
                        //   ? this.$store.getters.mqttVal(this.titleAll + "/Ia")
                        //   : 0) == 0 &&
                        // (this.$store.getters.mqttVal(this.titleAll + "/Ib")
                        //   ? this.$store.getters.mqttVal(this.titleAll + "/Ib")
                        //   : 0) == 0 &&
                        // (this.$store.getters.mqttVal(this.titleAll + "/Ic")
                        //   ? this.$store.getters.mqttVal(this.titleAll + "/Ic")
                        //   : 0) == 0
                        //   ? "--"
                        //   : Math.floor(
                        //       (this.$store.getters.mqttVal(this.titleAll + "/Ia") +
                        //         this.$store.getters.mqttVal(this.titleAll + "/Ib") +
                        //         this.$store.getters.mqttVal(this.titleAll + "/Ic")) *
                        //         100
                        //     ) / 100,

                        spanw: "A",
                    },
                    {
                        id: "4",
                        name: "有功功率",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/PAa") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PAa") / 1000) *
                                100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/PAb") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PAb") / 1000) *
                                100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/PAc") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PAc") / 1000) *
                                100
                            ) / 100 : "--",

                        amount4: this.$store.getters.mqttVal(this.titleAll + "/PA") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PA") / 1000) *
                                100
                            ) / 100 : "--",

                        spanw: "kW",
                    },
                    {
                        id: "5",
                        name: "无功功率",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/PRa") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PRa") / 1000) *
                                100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/PRb") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PRb") / 1000) *
                                100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/PRc") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PRc") / 1000) *
                                100
                            ) / 100 : "--",

                        amount4: this.$store.getters.mqttVal(this.titleAll + "/PR") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PR") / 1000) *
                                100
                            ) / 100 : "--",

                        spanw: "kVar",
                    },
                    {
                        id: "6",
                        amount4: this.$store.getters.mqttVal(this.titleAll + "/P") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/P") / 1000) * 100
                            ) / 100 : "--",
                        name: "视在功率",

                        amount1: this.$store.getters.mqttVal(this.titleAll + "/Pa") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/Pa") / 1000) *
                                100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/Pb") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/Pb") / 1000) *
                                100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/Pc") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/Pc") / 1000) *
                                100
                            ) / 100 : "--",
                        spanw: "kVA",
                    },
                    {
                        id: "7",
                        name: "功率因数",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/PFa") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/PFa") * 100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/PFb") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/PFb") * 100
                            ) / 100 : "--",
                        amount3: this.$store.getters.mqttVal(this.titleAll + "/PFc") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/PFc") * 100
                            ) / 100 : "--",
                        spanw: "/",
                        amount4: this.$store.getters.mqttVal(this.titleAll + "/PF") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/PF") * 100
                            ) / 100 : "--",
                    },
                    {
                        id: "8",
                        name: "有功电度",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/PA_imp") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/PA_imp") * 100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/PA_exp") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/PA_exp") * 100
                            ) / 100 : "--",
                        amount3: "--",
                        spanw: "kWh",
                        amount4: "--",
                    },
                    {
                        id: "9",
                        name: "无功电度",
                        amount1: this.$store.getters.mqttVal(this.titleAll + "/PR_imp") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PR_imp") /
                                    1000) *
                                100
                            ) / 100 : "--",
                        amount2: this.$store.getters.mqttVal(this.titleAll + "/PR_exp") ?
                            Math.floor(
                                (this.$store.getters.mqttVal(this.titleAll + "/PR_exp") /
                                    1000) *
                                100
                            ) / 100 : "--",
                        amount3: "--",
                        spanw: "kvarh",
                        amount4: "--",
                    },
                ];
            },

            Rhz() {
                return [{
                        id: 1,
                        name: "湿度/HR%",
                        data: "湿度",
                        Inimg: require("../assets/img/矢量智能对象.png"),
                        TemperatureA: "- -",
                    },
                    {
                        id: 2,
                        name: "频率/Hz",
                        data: "频率",
                        Inimg: require("../assets/img/矢量智能对象(1).png"),
                        TemperatureA: this.$store.getters.mqttVal(this.titleAll + "/Fa") ?
                            Math.floor(
                                this.$store.getters.mqttVal(this.titleAll + "/Fa") * 100
                            ) / 100 : "- -",
                    },
                ];
            },
            //主母线温度
            Listgxg() {
                return [{
                        id: 1,
                        name: "主母线温度/℃",
                        Inimg: require("../assets/img/温度.png"),
                        TemperatureA: "- -",
                        TemperatureB: "- -",
                        TemperatureC: "- -",
                    },
                    {
                        id: 2,
                        name: "断路器上口温度/℃",
                        Inimg: require("../assets/img/温度.png"),
                        TemperatureA: "- -",
                        //   this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     ? this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     : "- -",
                        TemperatureB: "- -",
                        //    this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     ? this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     : "- -",
                        TemperatureC: "- -",
                        //    this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     ? this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     : "- -",
                    },
                    {
                        id: 3,
                        name: "断路器下口温度/℃",
                        Inimg: require("../assets/img/温度.png"),
                        TemperatureA: "- -",
                        //   this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     ? this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     : "- -",
                        TemperatureB: "- -",
                        //    this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     ? this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     : "- -",
                        TemperatureC: "- -",
                        //    this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     ? this.$store.getters.mqttVal(this.titleAll + "/Ua")
                        //     : "- -",
                    },
                ];
            },
        },
        created() {
            connectMqtt();
            //初始值赋值
            this.titleAll = this.$store.state.subLoopUrl.LoopUrl;
            subscribe([this.titleAll]);
        },
        beforeRouteLeave(to, form, next) {
            window.localStorage.setItem(
                "currentLoop1",
                JSON.stringify(this.currentLoopDetails)
            );
            window.localStorage.setItem(
                "ovaIndx",
                this.current
            );
            next();
        },
        activated() {
            let index = window.localStorage.getItem("ovaIndx")

            let loopStr = window.localStorage.getItem("currentLoop1");
            this.currentLoopDetails = JSON.parse(loopStr);
            this.title = this.currentLoopDetails.loopName;
            this.drawer = false;
            this.current = this.currentLoopDetails.loopId
            this.$root.eventHub.$emit("YOUR_EVENT_NAME", this.currentLoopDetails);
            this.titleAll = this.currentLoopDetails.subLoopUrl;
            this.$store.commit("LoopUrlTS", this.currentLoopDetails.loopUrl);
            this.src = this.currentLoopDetails.loopMap;
        },

        mounted() {
            this.app();
        },
        beforeDestroy() {
            unsubscribe([this.titleAll]);
        },
        watch: {
            titleAll(n) {
                this.titleAll = n;
                subscribe([n]);
            },
        },
        methods: {
            //点击滚动条事件
            roll(index) {
                if (index == 2) {
                    //滚动的数值  或者  +- = 值  或者死的数值 就是相应位置
                    //还有相应的 scrollTop 方法
                    this.$refs.apk.scrollTop += 100;
                } else {
                    this.$refs.apk.scrollTop -= 100;
                }
            },

            //所有进线接口请求
            app() {
                // chainIndex.AllInLine(4).then((res) => {
                chainIndex.AllInLine(this.$store.state.proproT.AllId).then((res) => {
                    this.Isshow = res.data.data;
                    this.bgonClick = res.data.data.loops;
                    if (this.bgonClick.length > 18) {
                        this.test = "没有更多了";
                    } else {
                        this.test = "";
                    }
                    this.titleAll = res.data.data.loops[0].subLoopUrl
                    this.current = res.data.data.loops[0].loopId;
                    this.src = res.data.data.loops[0].loopMap;
                    this.title = res.data.data.loops[0].loopName;
                });
            },
            //点击事件
            add(index, item) {
                this.currentLoopDetails = item;
                this.current = index
                if (index) {
                    this.title = item.loopName;
                    this.drawer = false;
                    this.$root.eventHub.$emit("YOUR_EVENT_NAME", item);
                    this.titleAll = item.subLoopUrl;

                    this.$store.commit("LoopUrlTS", item.loopUrl);
                }
                this.src = item.loopMap;
            },
            //改变表头颜色
            tableHeaderColor({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                if (rowIndex === 0) {
                    return "background-color:rgba(0, 0, 0,0.06);color: #000000;font-weight: 700";
                }
            },
            //改变table颜色
            tableRowClassName({
                rowIndex
            }) {
                if (rowIndex % 2 != 0) {
                    //=>这里可以改成 rowIndex%2=== 1，后面直接else即可达到隔行变色效果。
                    return "warning-row";
                }
                return "";
            },
        },
    };
</script>
<style lang="less" scoped>


    .head {
        width: 100%;
        height: 48rem;
        display: flex;
        margin-bottom: 24rem;

        .name {
            width: 440rem;
            height: 100%;
            background: #ffffff;
            display: flex;
            // padding: 12rem 17rem 0 24rem;
            justify-content: center;
            align-items: center;

            .spa {
                // width: 252rem;
                font-size: 26rem;
                font-weight: 400;
                color: #333333;
                margin-left: 17rem;
                font-weight: 400;
                // line-height: 44rem;
                font-family: "YouSheBiaoTiHei-2";
                text-align: center;
                // display: flex;
                // align-items: center;
            }

            .oimg {
                width: 24rem;
                height: 24rem;

                img {
                    width: 24rem;
                    height: 24rem;
                }
            }
        }

        .tatel {
            width: 560rem;
            height: 48rem;
            background: #ffffff;
            border: 1rem solid rgba(0, 0, 0, 0.01);
            padding: 12rem 0 12rem 24rem;
            box-shadow: 0rem 3rem 14rem 0rem rgba(3, 13, 24, 0.26);
            border-radius: 0rem 0rem 8rem 8rem;
            display: flex;
            align-items: center;
            text-align: center;

            .miti {
                width: 22rem;
                height: 22rem;

                i {
                    font-size: 22rem;
                    color: chocolate;
                }
            }

            .mixin {
                margin-left: 18rem;
                font-size: 24rem;
                font-weight: 400;
                margin-top: -2rem;
                // color: #cccccc;
                color: #666666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .ova {
        display: flex;
        padding: 0 24rem;

        //   align-items: center;
        .infinite-list {
            height: 900rem;
        }

        // .infinite-list::-webkit-scrollbar {
        //   display: none;
        // }
        .el-dropdown-link {
            cursor: pointer;
            color: #409eff;
        }

        .el-icon-arrow-down {
            font-size: 12rem;
        }

        .left-hand {
            .Pngfute {
                width: 330rem;
                height: 602rem;
                padding: 25rem 0;
                background: url(../assets/img/bg.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;

                .oimg {
                    width: 280rem;
                    height: 552rem;
                    background-color: #fff;
                    margin: auto;
                }

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .state {
                margin-top: -2rem;
                background-image: url(../assets/img/倒影@2x.png);
                background-size: 100% 100%;
                width: 330rem;
                height: 53rem;
                margin-bottom: 6rem;
            }
  
            .trigger {
                margin: auto;
                width: 195rem;
                height: 81rem;
                background-image: url(../assets/img/btnstuts.png);
                background-size: 195rem 81rem;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0rem 10rem 10rem 0;
                background-repeat: no-repeat;
                margin-bottom: 20rem;
                .jadk {
                    text-align: center;
                    line-height: 50rem;
                    border-bottom: 1rem solid rgb(209, 206, 206);
                }

                // .jadk:hover {
                //     box-shadow: 20rem 10rem 20rem gray;
                // }
                .array {
                    color: #ffffff;
                    background-color: #5b8ff9;
                    box-shadow: 5rem 1rem 10rem #5b8ff9;
                    border-bottom: 1rem solid #5b8ff9;
                }

                .el-icon-sort {
                    font-size: 22rem;
                }

                .swtrGet {
                    font-size: 24rem;
                    font-weight: 500;
                    color: #333333;
                    cursor: pointer;
                    margin-left: 8rem;
                    // margin-top: 4rem;
                }
            }
        }

        .javafort {
            margin-left: 23rem;

            .table-ele {
                width: 1040rem;
                height: 100%;
            }

            // <!-- 需要更改的 -->
            // .Humidity,
            // .Temperature {
            //     // background-color: rebeccapurple;
            //     margin-top: 16rem;
            //     display: flex;

            //     .web-left {
            //         width: 240rem;
            //         // display: flex;
            //         // margin-left: 22rem;
            //         position: relative;
            //         margin-right: 32rem;

            //         .header {
            //             width: 240rem;
            //             height: 34rem;
            //             background-image: url(../assets/img/terrfunt.png);
            //             background-color: #fff;
            //             display: flex;
            //             align-items: center;
            //             padding: 0 16rem;
            //             border: 1rem solid rgba(0, 0, 0, 0.15);
            //             box-shadow: 0rem 1rem 5rem 0rem rgba(14, 5, 10, 0.1) inset;

            //             color: rgba(51, 51, 51);
            //             border-radius: 2rem;

            //             .felx-right {
            //                 width: 100%;
            //                 display: flex;
            //                 justify-content: space-between;
            //                 align-items: center;
            //                 font-size: 18rem;
            //                 margin-left: 8rem;

            //                 .header-Icon {
            //                     display: flex;
            //                     align-items: center;

            //                     img {
            //                         width: 100%;
            //                         height: 18rem;
            //                     }


            //                 }


            //                 .header-name {
            //                     display: flex;
            //                     align-items: center;
            //                 }
            //             }

            //             .header-one {
            //                 width: 16rem;
            //                 height: 16rem;
            //                 background: #ff9d4d;
            //                 font-weight: 400;
            //                 color: #ffffff;
            //                 font-size: 14rem;
            //                 text-align: center;
            //                 line-height: 16rem;
            //                 border-radius: 2rem;
            //             }
            //         }

            //         .Temperature-item {
            //             // background-color: blue;
            //             width: 240rem;
            //             height: 96rem;
            //             margin-top: 12rem;
            //             background: #ffffff;
            //             border: 1rem solid rgba(14, 5, 10, 0.06);
            //             box-shadow: 0rem 4rem 10rem 0rem rgba(14, 5, 10, 0.1);

            //             .ABC {
            //                 padding-left: 17rem;
            //                 padding-right: 5rem;
            //                 width: 100%;
            //                 line-height: 32rem;
            //                 height: 32rem;
            //                 display: flex;
            //                 justify-content: space-between;
            //                 background-color: #ffffff;
            //                 border: 1rem solid rgba(0, 0, 0, 0.15);
            //                 font-size: 18rem;

            //                 span:last-child {
            //                     color: black;
            //                     font-weight: 400;
            //                 }

            //                 span {
            //                     color: #999999;
            //                     font-weight: 400;
            //                 }
            //             }
            //         }
            //     }
            // }

            // .Humidity {
            //     margin-top: 19rem;
            // }
        }
    }

    .demo1 {

        em,
        span {
            display: block;
            width: 30rem;
            height: 16rem;
            font-size: 30rem;
            overflow: hidden;
            position: absolute;
            top: 47rem;
            left: 203rem;
        }

        em {
            margin-top: -16rem;
            color: rgba(0, 0, 0, 0.15);
            font-style: normal;
        }

        span {
            margin-top: -14rem;
            color: white;
        }
    }

    .vue-drag-scroll-out-wrapper::-webkit-scrollbar {
        display: none;
    }

    .vue-drag-scroll-out-wrapper {
        width: 100%;
        overflow-x: hidden;
        /* width: 100%; */
        // height: 100%;
        cursor: grab;
        position: absolute;
        top: 0;
        left: 0;
        padding-top: 50rem;
    }

    .mar {
        margin: auto;

        .tors {
            width: 400rem;
            height: 400rem;
            margin: auto;
            // background-color: red;
            text-align: center;

            img {
                margin-top: 88rem;
                margin-right: 80rem;
                margin-left: 80rem;
            }

            .oP {
                font-size: 18rem;
                font-weight: 400;
                color: #999999;
                margin-top: 24rem;
            }
        }
    }

    .fors {
        display: flex;
        // text-align: center;
    }

    .a {
        color: #0d94ff;
    }

    .upward {
        position: absolute;
        width: 100%;
        height: 50rem;
        top: 0;
        background-color: #ffffff;
        text-align: center;
        font-size: 28rem;
        line-height: 50rem;
        border-bottom: 1rem solid rgba(128, 128, 128, 0.4);
        z-index: 9999;
        // box-shadow: 5rem 1rem 5rem 1rem gray;
    }

    .downward {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50rem;
        background-color: #fff;
        text-align: center;
        line-height: 50rem;
        font-size: 28rem !important;
        border-top: 1rem solid rgba(128, 128, 128, 0.4);
        z-index: 9999;
        box-shadow: 5rem 5rem 5rem 5rem gray;
    }

    .nonum {
        text-align: center;
        padding-bottom: 100rem;
        padding-top: 20rem;
        color: rgb(189, 189, 189, 0.5);
        padding-top: 240rem;
    }

    // .jatave{
    //   text-align: center;
    //   padding-top: 240rem;

    // }
    // .terr{
    //   position: absolute;
    //       width: 0;
    //     height: 0;
    //     left: 208rem;
    //     top: 40rem;
    //   border-left:10rem solid transparent;
    //     border-right:10rem solid transparent;
    //     border-bottom:10rem solid rgba(0, 0, 0, 0.15);;
    // }
    // .Temperature-item:before{
    //      width: 20rem;
    //      height: 20rem;
    //     position:absolute;

    //     border-top:0.6rem solid transparent;
    //     border-right:0.6rem solid #F2F6F4 ;
    //     border-bottom: 0.6rem solid transparent;

    // }
</style>